import { useContext, useEffect, useRef } from 'react';

import { useAppDispatch, useAppSelector } from 'state/hooks';
import { selectShowBarbs, setShowBarbs } from 'state/workflowSlice';

import { MapContext } from '../MapContext';
import { MapControl } from '../utils/mapControls';
import { setLayerVisibility } from '../utils/mapUtils';
import { kTicksShowHideId } from '../utils/map_constants';

export function useBarbs(barbLayer: string) {
  const { refMap } = useContext(MapContext);
  const dispatch = useAppDispatch();
  const showBarbs = useAppSelector(selectShowBarbs);
  const refShowBars = useRef(showBarbs);

  useEffect(() => {
    refShowBars.current = showBarbs;
  }, [showBarbs]);

  function handleTicksShowHideClickCallback() {
    const newVal = !refShowBars.current;
    dispatch(setShowBarbs(newVal));
    MapControl.setValue(newVal, kTicksShowHideId);
    setLayerVisibility(newVal, barbLayer, refMap.current);
  }

  return handleTicksShowHideClickCallback;
}
